import React from 'react'

export const Register = () => {
    return (
        <div>
            Soy el register
        </div>
    )
}
